<script>

    import { toast } from 'bulma-toast'
    import { TrackingsStore, ShipmentStore } from '../stores'
    
    import TrackingsService from '../$services/trackings.service'
    import DateMethods from '../$methods/date.methods'

    import TrackingLink from './tracking.link.svelte'
    import Message from '../$components/message.svelte'
    import Spinner from '../$components/spinner.svelte'

    let loading = false
    let query = {}

    getTrackingsShipment()
    
    async function getTrackingsShipment() {
    
        loading = true
        const resp = await TrackingsService.getTrackingsShipment($ShipmentStore._id, query)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        TrackingsStore.set(resp.data)
    }

</script>

<TrackingLink shipmetId={ $ShipmentStore._id } />
<hr>

<Spinner {loading} />
<Message show={!loading && !$TrackingsStore.length} />

{#if $TrackingsStore.length && !loading}
    <div class="timeline">
        <header class="timeline-header">
        <span class="tag is-medium is-primary">Inicio</span>
        </header>
        {#each $TrackingsStore as tracking}
            <div class="timeline-item">
                <div class="timeline-marker is-icon">
                    <i class="fa fa-flag"></i>
                </div>
                <div class="timeline-content">
                    <p class="heading">{ DateMethods.dateTimeLarge(tracking.created) }</p>
                    <div>
                        <div class="title is-5">{ tracking.name }</div>
                        <div class="subtitle is-6">{ tracking.details }</div>
                    </div>
                </div>
            </div>
            {#if tracking.status === 'Entregado'}
                <div class="timeline-header">
                    <span class="tag is-medium is-primary">Finalizado</span>
                </div>
            {/if}
        {/each}
    </div>
{/if}